// useAutosize.js
import { useRef, useLayoutEffect } from 'react';

/**********************************************************************
 *  GLOBAL AUTOSIZE REGISTRY (lives once per module)
 *********************************************************************/
// A Set that remembers every textarea DOM node that wants autosizing
const autosizeRegistry = new Set();
// requestAnimationFrame handle so we resize at most once per frame
let rafId = null;

// Resize every registered element
function resizeAll() {
  autosizeRegistry.forEach(el => {
    //console.log('el.scrollHeight:', el.scrollHeight);
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  });
}

// Throttle with requestAnimationFrame
function scheduleResizeAll() {
  if (rafId == null) {
    rafId = requestAnimationFrame(() => {
      rafId = null;
      resizeAll();
    });
  }
}

// Attach ONE window listener the first time this module is evaluated
if (typeof window !== 'undefined' && !window.__autosizeListenerAttached) {
  window.addEventListener('resize', scheduleResizeAll);
  window.__autosizeListenerAttached = true;           // flag = “already done”
}

/**********************************************************************
 *  useAutosize hook  (unchanged call-site API)
 *********************************************************************/
export { scheduleResizeAll }; // Add this line
export default function useAutosize(value) {
  const ref = useRef(null);

  // 1. resize when this textarea's value changes
  useLayoutEffect(() => {
    if (!ref.current) return;
    //resizeAll();                     // instant adjust for initial paint/value update
    scheduleResizeAll();
  }, [value]);

  // 2. register / unregister in the global Set
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    autosizeRegistry.add(el);
    scheduleResizeAll();
    return () => autosizeRegistry.delete(el);
  }, []);

  // caller just spreads these props
  return {
    innerRef: ref,                   // Reactstrap’s ref prop
    rows: 1,
    style: { resize: 'none', overflow: 'hidden' }
  };
}



